import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfStatus } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';

const initialValuesOfStatus = {
	ORGAO: '',
	DESCRICAO: '',
};

export const useListStatusController = () => {
	const [statusData, setStatusData] = useState<ModelOfStatus[]>([]);
	const [selectedStatus, setSelectedStatus] = useState<ModelOfStatus>(initialValuesOfStatus);
	const [loading, setLoading] = useState(true);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const { userAgencyId } = useAuth();

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const getStatus = () => {
		api.get('status')
			.then(response => {
				setStatusData(
					response.data.filter((item: any) => {
						return item.ORGAO === userAgencyId;
					}),
				);
				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const removeStatus = (Status: ModelOfStatus) => {
		setLoading(true);
		api.delete(`status/${Status.ID}`)
			.then(() => {
				getStatus();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O status foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getStatus();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editStatus = (Status: ModelOfStatus) => {
		setLoading(true);

		const editedStatus: ModelOfStatus = {
			...Status,
		};

		api.put(`status/${selectedStatus?.ID}`, editedStatus)
			.then(() => {
				getStatus();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O status foi editada com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getStatus();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getStatus();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const openDeleteDialog = (Status: ModelOfStatus) => {
		setDeleteDialog(true);
		setSelectedStatus(Status);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (Status: ModelOfStatus) => {
		setEditDialog(true);
		setSelectedStatus(Status);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfStatus>({
		initialValues: {
			DESCRICAO: '',
		},
		onSubmit: async values => await editStatus(values),
		validationSchema,
	});

	return {
		getStatusListController: {
			formik,
			statusData,
			selectedStatus,
			loading,
			deleteDialog,
			editDialog,
			toast,
		},
		handleStatusListController: {
			removeStatus,
			editStatus,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
		},
	};
};
